<template>
  <VuePerfectScrollbar class="blocks-and-alerts">
    <div v-for="(events, day, index) in groupedDeviceEvents"
         class="day"
         :key="index">
      <div class="day-header">
        <div class="day-name">
          {{ day | relativeTimeInDays(2) | capitalize }}
        </div>
      </div>
      <ul class="days-list">
        <blocks-and-alerts-item v-for="(event, index) in events"
                                :key="index"
                                :item="event"

                                @allowUrl="onUrlAllow"
                                @blockUrl="onUrlBlock" />
      </ul>
    </div>
    <portal to="modals">
        <alert-modal :show="showModal"
                     :blocked-url="blockedUrl"

                     @close="closeAlertModal"
                     @confirm="onBlockingConfirm"
                     @cancel="onBlockingCancel" />
    </portal>
    <base-scroll-to-top />
  </VuePerfectScrollbar>
</template>

<script>
  import BlocksAndAlertsItem from './BlocksAndAlertsItem.vue'
  import AlertModal from './UrlBlockingAlertModal.vue'
  import VuePerfectScrollbar from 'vue-perfect-scrollbar'
  import analytics from '@/services/analytics.js'
  import urlsApi from '@/api/urlSetting.js'

  export default {
    props: {
      deviceEvents: {
        type: Array,
        required: true
      },

      modeId: {
        type: String,
        required: true
      }
    },

    components: {
      BlocksAndAlertsItem,
      VuePerfectScrollbar,
      AlertModal
    },

    data() {
      return {
        showModal: false,
        blockedUrl: ''
      }
    },

    methods: {
      onUrlAllow(setting) {
        let modeId = this.modeId
        let url = setting.url
        let mode = setting.mode

        urlsApi.create(modeId, url, mode).then(() => {
          analytics.sendEvent('St_AllowBlock_BlkAlrtRpt')
        })
      },

      onUrlBlock(settings) {
        this.blockedUrl = settings.url
        this.showModal = true
      },

      onBlockingConfirm() {
        let modeId = this.modeId
        let url = this.blockedUrl
        let mode = 'block'

        urlsApi.create(modeId, url, mode)
          .then(() => {
            this.blockedUrl = ''
            this.showModal = false
            analytics.sendEvent('St_AllowBlock_BlkAlrtRpt')
          })
      },

      onBlockingCancel() {
        this.blockedUrl = ''
        this.showModal = false
      },

      closeAlertModal() {
        this.showModal = false
      }
    },

    computed: {
      groupedDeviceEvents() {
        return _.groupBy(
          this.deviceEvents,
          // transform the date string to milliseconds of the beginning of the day
          // "2021-02-01T00:01:00.000Z" => 1611964800000 (milliseconds)
          search => +new Date(search.time).setHours(0,0,0,0)
        )
      }
    }
  }
</script>

<style lang="scss" scoped>
  .blocks-and-alerts {
    height: 100%;
    position: relative;

    .day-header {
      display: flex;
      justify-content: center;
      margin: 25px 0 15px 0;
    }

    .day-name {
      opacity: .3;
      color: #fff;
      background: #6a6a6a;
      font-size: 16px;
      border-radius: 14px;
      padding: 5px 16px 5px 16px;
    }

    .days-list {
      list-style: none;
      padding: 0;
      margin: 0;
    }
  }
</style>
